<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Manage Matches">
            <div class="filter-bar ui basic segment grid">
              <div class="ui form">
                <div class="inline field">
                  <label>Search for:</label>
                  <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="code, description, bookmaker">
                  <button class="ui primary button" @click="doFilter">Go</button>
                  <button class="ui button" @click="resetFilter">Reset</button>
                </div>
              </div>
            </div>
            <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions">
              <template slot="versus" slot-scope="props">
                {{ props.rowData.home_name }} vs {{ props.rowData.away_name }}
              </template>
              <template slot="odds" slot-scope="props">
                 <div v-for="(bookmaker, index) in props.rowData.odds" :key="index">
                    <strong>{{ bookmaker._attributes.name }}</strong> - <small>1: {{ bookmaker.odd[0]._attributes.value }} | X: {{ bookmaker.odd[2]._attributes.value }} | 2: {{ bookmaker.odd[1]._attributes.value }}</small>
                  </div>
              </template>
              <template slot="actions" slot-scope="props">
                <div class="table-button-container">
                  <button class="btn btn-info" @click="editMatch(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
                  <button class="btn btn-danger" @click="deleteMatch(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
                </div>
              </template>
            </vuetable>
            <div class="vuetable-pagination ui basic segment grid">
              <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
              <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      moreParams: {},
      filterText: '',

      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'country',
          title: 'Country',
          titleClass: 'text-center',
          sortField: 'country',
          callback: 'formatCountry'
        },
        {
          name: '__slot:versus',
          title: 'Versus',
          titleClass: 'text-center',
          sortField: 'home_name'
        },
        {
          name: '__slot:odds',
          title: 'Odds',
          titleClass: 'text-center'
        },
        {
          name: 'draft',
          title: 'Active',
          titleClass: 'text-center',
          callback: 'formatDraft',
          sortField: 'draft'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: 'updated_at',
          title: 'Updated',
          sortField: 'updated_at',
          callback: 'formatDate'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    formatCountry (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    formatDraft (value) {
      return (value)
        ? ''
        : '<i class="fas fa-check-square"></i>'
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatActions (value) {
      return `<i ref="delete_${value}" @click="console.log('test')" class="fas fa-trash-alt"></i>`
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteMatch (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/matches/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('Match deleted!')
        })
      } else {
        alert('Match not deleted!')
      }
    },
    editMatch (data) {
      this.$router.push(`/matches/edit/${data._id}`)
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.filterText = ''
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  created () {
    this.api_url = `${this.$api_url}/matches`
  }
}
</script>

<style scoped>

</style>
